export default __webpack_public_path__ + "static/media/2260.d14e1b9d.png";